// The server requires a passing probe for both `validated` and `live` (PROBE_REQUIRED in
// packages/services/connectors.ts), so a row that has never passed one offers the move disabled
// rather than letting the click come back as a 409.
const TRANSITIONS = {
  draft: [{ to: 'validated', label: 'Mark validated', needsProbe: true, confirm: false }],
  validated: [{ to: 'live', label: 'Go live', needsProbe: true, confirm: true }],
  live: [{ to: 'disabled', label: 'Disable', needsProbe: false, confirm: true }],
  disabled: [{ to: 'live', label: 'Go live', needsProbe: true, confirm: true }],
};

export const probePassed = (instance) => instance?.lastProbeResult?.ok === true;

export const nextTransitions = (status) => TRANSITIONS[status] || [];

// A store tool has no contract to read; its identity is the name it mounts under.
export const instanceLabel = (instance) =>
  instance?.tool ? `store_${instance.tool.name}` : instance?.contracts?.[0] || null;

export const confirmFor = (to, instance) => {
  const isTool = !!instance?.tool;
  const label = instanceLabel(instance) || 'this capability';

  if (to === 'live') {
    return {
      title: 'Go live',
      body: isTool
        ? `The assistant gains the tool ${label} for every shopper conversation on this store, starting now.`
        : `${label} is answered by this API for every shopper conversation on this store, starting now. Live calls use the real shopper's identity, not the probe's.`,
      note: isTool
        ? 'You can disable at any time; the assistant then loses this tool.'
        : `You can disable at any time; the assistant then says ${label} is not available for this store.`,
      cta: 'Go live',
      color: 'success',
    };
  }

  if (to === 'disabled') {
    return {
      title: 'Disable connector',
      body: isTool
        ? `The assistant loses this tool; ${label} disappears from the shopper conversation for this store.`
        : `The assistant stops answering with ${label} for this store and says so instead; it drops to the coverage line.`,
      note: 'Re-enable with Go live while the last probe still passes, or edit the draft and probe again.',
      cta: 'Disable',
      color: 'danger',
    };
  }

  return null;
};

export const transitionMessage = (to, instance) => {
  const isTool = !!instance?.tool;
  const label = instanceLabel(instance) || 'The connector';

  if (isTool) {
    if (to === 'live') return `The assistant gains the tool ${label}.`;
    if (to === 'disabled') return 'The assistant loses this tool.';
  }

  return `${label} is now ${to}.`;
};
